import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-assignation-dropdown',
  templateUrl: './assignation-dropdown.component.html',
  styleUrls: ['./assignation-dropdown.component.scss']
})
export class AssignationDropdownComponent implements OnInit {
  @Input() items = [];
  @Input() dropdownVisible = false;
  @Input() selectedItem: any;
  @Input() readonly = false;

  @Output() onSelect = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  toggleDropdown(event: any) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!this.readonly) {
      this.dropdownVisible = !this.dropdownVisible;
    }
  }

  handleAssign(item: any) {
    if (this.readonly) {
      return;
    }
    this.selectedItem = item;
    this.onSelect.emit(item);
    this.dropdownVisible = false;
  }

  reset() {
    this.selectedItem = null;
  }

  get dropdownItems() {
    return this.items.filter(item => !this.selectedItem || item.id !== this.selectedItem.id);
  }

  get selected() {
    return this.selectedItem;
  }

}
